/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { NavLink, useLocation } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageListItem from '@mui/material/ImageListItem';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RestoreIcon from '@mui/icons-material/Restore';
import CallIcon from '@mui/icons-material/Call';
import SettingsIcon from '@mui/icons-material/Settings';
import { Hidden, Box } from '@mui/material';
import MobileSidebar from './MobileSidebar';
import inetlogo from '../../assets/images/inetlogo.png';

const drawerWidth = 260;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const items = [
  {
    href: '/show-invoice',
    icon: AssignmentIcon,
    title: 'รายการค้างชำระเงิน',
    sub: [],
  },
  {
    href: '/payment-list-user',
    icon: RestoreIcon,
    title: 'ประวัติการชำระเงิน',
    sub: [],
  },
  // {
  //   href: '/setting',
  //   icon: SettingsIcon,
  //   title: 'บัญชีผู้ใช้',
  //   sub: [],
  // },
  // {
  //   href: '/contact',
  //   icon: CallIcon,
  //   title: 'ติดต่อ',
  //   sub: [],
  // },
];

export default function MiniDrawer({ onMobileClose, openMobile, children }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Hidden lgDown>
        <Drawer variant="permanent" open={open}>
          <ListItem disablePadding sx={{ display: 'flex' }}>
            <ListItemButton
              onClick={() => {
                if (open) {
                  handleDrawerClose();
                } else {
                  handleDrawerOpen();
                }
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
              }}
            >
              <ImageListItem sx={{ maxWidth: open ? '50px' : '60px' }}>
                <img src={`${inetlogo}`} />
              </ImageListItem>
              <ListItemText
                sx={{ opacity: open ? 1 : 0, ml: open ? '10px' : 0 }}
              >
                <div className="text-sm">Internet Thailand</div>
                <div className="text-sm">Public Company Limited</div>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <List sx={{}}>
            {items.map((item) => (
              <NavLink key={item.title} to={item.href}>
                <ListItem
                  sx={{
                    display: 'block',
                    ...(item.href === location.pathname && {
                      backgroundColor: 'lightGreen.main',
                      borderRadius: 3,
                      color: 'lightGreen.text',
                    }),
                  }}
                >
                  <ListItemButton
                    sx={{
                      height: 40,
                      justifyContent: open ? 'initial' : 'center',
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <item.icon
                        sx={{
                          ...(item.href === location.pathname && {
                            color: 'lightGreen.text',
                          }),
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.title}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            ))}
          </List>
        </Drawer>
      </Hidden>

      <Hidden lgUp>
        <MobileSidebar
          onMobileClose={onMobileClose}
          openMobile={openMobile}
          items={items}
        />
      </Hidden>
      {/* <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: 'auto' }}>
        <DrawerHeader />
        <div className="container">{children}</div>
      </Box> */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}
